import React from 'react';
import { XContainer } from '../styles/GlobalStyle';

const Page404 = () => {
	console.log('called 404');
	return (
		<>
			<XContainer
				fluid
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '100vh', // Ensure full viewport height
					textAlign: 'center', // Center the text
				}}
			>
				<img
					src="/images/not-found-404.svg"
					// style={{
					// 	width: '20px',
					// }}
					alt="404"
				/>
				<h1 style={{ color: '#007299' }}>404</h1>
				<span style={{ color: '#D3D3D3', fontSize: '24px' }}>
					Page Not Found
				</span>
			</XContainer>
		</>
	);
};

export default Page404;
